import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostExternalIntegrationStartStageMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			etlStage,
			integrationProvider,
			forceAll,
		}: {
			etlStage: Api.EtlStage;
			integrationProvider: Api.IntegrationProvider;
			forceAll?: boolean;
		}) => {
			let queryParams;
			if (forceAll) {
				queryParams = { [etlStage === Api.EtlStage.Extract ? 'forceExtractAll' : 'forceTransformAll']: true };
			}

			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/${etlStage.toLowerCase()}`,
					queryParams,
				}),
				'POST'
			);
		},
		onError,
		onSuccess,
	});
};
